module.exports = __webpack_public_path__ + "img/gys_14@2x.cd324fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_14@2x.png
// module id = whGp
// module chunks = 0